"use client"

import React from "react"
import { Info } from "lucide-react"

import { useHasHover } from "@/lib/helper"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/components"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/components/tooltip"
import { UbTooltipStoryblok } from "@/components/storyblok/component-types"
import UbRichText from "@/components/storyblok/UbRichText"

interface TooltipClientProps {
  blok?: UbTooltipStoryblok
  tooltip_content?: React.ReactNode
  trigger_content?: React.ReactNode
  text?: string
}

export default function TooltipClient(props: TooltipClientProps) {
  const tooltipContent = props.blok?.tooltip_content?.[0]
  const hasHover = useHasHover()

  return (
    <>
      {hasHover ? (
        <Tooltip>
          <TooltipTrigger asChild>
            {props.trigger_content ? (
              <div className={"w-fit"}>{props.trigger_content}</div>
            ) : (
              <Info className={"size-4 text-gray-400"} />
            )}
          </TooltipTrigger>
          <TooltipContent>
            {tooltipContent?.component === "ub_rich_text" ? (
              <UbRichText blok={tooltipContent} />
            ) : props.tooltip_content ? (
              <div className={"max-w-sm"}>{props.tooltip_content}</div>
            ) : (
              <div className={"max-w-sm"}>{props?.blok?.tooltip_text ?? props.text ?? ""}</div>
            )}
          </TooltipContent>
        </Tooltip>
      ) : (
        <Popover>
          <PopoverTrigger asChild>
            {props.trigger_content ? (
              <div className={"w-fit"}>{props.trigger_content}</div>
            ) : (
              <Info className={"size-4 text-gray-400"} />
            )}
          </PopoverTrigger>
          <PopoverContent className="w-fit">
            {tooltipContent?.component === "ub_rich_text" ? (
              <UbRichText blok={tooltipContent} />
            ) : props.tooltip_content ? (
              <div className={"max-w-sm"}>{props.tooltip_content}</div>
            ) : (
              <div className={"max-w-sm"}>{props?.blok?.tooltip_text ?? props.text ?? ""}</div>
            )}
          </PopoverContent>
        </Popover>
      )}
    </>
  )
}
